import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { createSubFarm, createSubFarmfSuperAdmin } from "../../../modules/farmManagement/action";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import SubFarmForm from "./SubFarmForm";


class CreateSubFarm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      successMessage: ""
    };
  }

  handleSubmit = farmInfo => {
    if(isSuperAdmin()){
      farmInfo['id'] = this.props.MainFarmId;
      this.props.createSubFarmfSuperAdmin(farmInfo);
    } else {
      this.props.createSubFarm(farmInfo);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.farmCreated && nextProps.farmCreated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  getMainFarmName = (MainFarmId) => {
    let farm = this.props.MainFarmsList.filter(
      farm => farm.id === MainFarmId
    );
    return farm[0] && farm[0].name;
  }

  render() {
    const { successMessage } = this.state;

    if (successMessage) {
      if(isSuperAdmin()){
        return <Redirect to="/farmmanagement" />;
      }
      else {
        return <Redirect to="/subFarmsList" />; 
      }  
    }

    return (
      <SubFarmForm
        formLabel="Create Sub Farm"
        buttonLabel="Add sub farm"
        handleSubmit={this.handleSubmit}
        MainFarmName={this.getMainFarmName(this.props.MainFarmId)}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    farmCreated: state.FarmManagementReducer.farmCreated,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    MainFarmsList: state.FarmManagementReducer.MainFarmsList
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ createSubFarm, createSubFarmfSuperAdmin }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateSubFarm);



// WEBPACK FOOTER //
// ./src/components/private/FarmManagment/CreateSubFarm.js